import { render, staticRenderFns } from "./theme2.vue?vue&type=template&id=3b7d436a&scoped=true"
import script from "./theme2.vue?vue&type=script&lang=js"
export * from "./theme2.vue?vue&type=script&lang=js"
import style0 from "./theme2.vue?vue&type=style&index=0&id=3b7d436a&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d436a",
  null
  
)

export default component.exports